import { render, staticRenderFns } from "./HomeTagList.vue?vue&type=template&id=21a9bc5c&scoped=true&"
import script from "./HomeTagList.vue?vue&type=script&lang=js&"
export * from "./HomeTagList.vue?vue&type=script&lang=js&"
import style0 from "./HomeTagList.vue?vue&type=style&index=0&id=21a9bc5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a9bc5c",
  null
  
)

export default component.exports